import styled from 'styled-components'

export const ImmediateUnderDiv = styled.div`
display:flex;

justify-content:center;



`